<template>
    <div class="warehouse_add_wrap">
        <div class="warehouse_add_top">
            <div class="warehouse_add_code_identification">
                <div></div>
                <el-button  size="small" type="primary" @click="handleClickCodeIdentification">编码识别</el-button>
            </div>

            <div class="warehouse_add_table" v-loading="loading">
                <el-table class="custom_table" :data="formData.productData" border  ref="table" max-height="530" >
                    <el-table-column label="产品名称" prop="name" class-name=" tableInputColumn"	 min-width="434px">
                        <template slot-scope="{row}">
                            <div class="product_name_flex">
                                <el-autocomplete size="small" v-model="row.name" value-key="name"  :fetch-suggestions="(queryString, cb) => productNameQuerySearchAsync(queryString, cb, row)" placeholder="请输入产品名称"  @select="handleSelectProduct($event,row)" >
                                    <template slot-scope="{ item }">
                                        <div class="flex_js_wrap">
                                            <div class="product_name ellipsis">{{ item.name }}</div>
                                            <div class="product_tag" v-if="item.stock_status !='未入库'">入过</div>
                                        </div>
                                    </template>
                                </el-autocomplete>
                                <el-tooltip class="item" effect="dark" content="更多产品" placement="top">
                                     <span class="handle_icon_wrap" @click="handleClickSelectProduct(row)">
                                        <i class="iconfont icon-cangku1"></i>
                                     </span>
                                </el-tooltip>

                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column label="入库仓库" prop="stock_id"  width="226px" class-name="tableInputColumn">
                        <template #header>
                            <span style="margin-right: 4px">入库仓库</span>
                            <el-popover placement="bottom" ref="stockPopover">
                                <span slot="reference">
                                    <el-tooltip class="item" content="批量入库" effect="dark" placement="top">
                                        <span class="handle_icon_wrap"><i class="iconfont icon-a-tianjiamiaobian"></i></span>
                                    </el-tooltip>
                                </span>
                                <el-select  @change="handleChangeProductStockAll($event)"   class="tableInput" placeholder="请选择入库仓库"  remote  reserve-keyword v-model="stock_id">
                                    <el-option :key="item.stock_id" :label="item.name" :value="item.id" v-for="item in stockList"> </el-option>
                                </el-select>
                            </el-popover>
                        </template>
                        <template slot-scope="{row}">
                            <el-select v-model="row.stock_id" placeholder="请选择入库仓库">
                                <el-option :key="item.stock_id" :label="item.name" :value="item.id" v-for="item in stockList"> </el-option>
                            </el-select>
                        </template>
                    </el-table-column>
                    <el-table-column label="单位" prop="unit"   width="90px" class-name="tableInputColumn">
                        <template slot-scope="{row}">
                            <el-input v-model="row.unit" placeholder="请输入单位" :disabled="(row.sku_id || (row.code_type && row.code_type == 'encoding_detection') ) ? true: false" size="small"></el-input>
                        </template>
                    </el-table-column>
                    <el-table-column label="产品单价（¥）" prop="cost_price"  align="center" width="155px" class-name="tableInputColumn">
                        <template slot-scope="{row}">
                            <el-input-number v-model="row.cost_price" :controls="false" :disabled="row.code_type && row.code_type == 'encoding_detection' ? true: false" size="small" placeholder="--" :min="0" ></el-input-number>
                        </template>
                    </el-table-column>

                    <el-table-column label="入库数量/产品编码" prop="id" min-width="332px"  class-name="tableInputColumn">
                        <template slot-scope="{row}">
                            <div class="product_num_code">
                                <el-input type="mini" v-model="row.no_code_num" placeholder="请输入数量" @change="handleChangeNum(row)"></el-input>
                                <div class="line"></div>
                                <div class="change_code">
                                    <el-popover  placement="bottom"  popper-class="product_code_popper" title=""  width="226"  trigger="hover">
                                            <span class="change_code_wrap" slot="reference" @click="handleClickSelectCode(row)">
                                               <i class="el-icon-circle-plus-outline"></i>
                                               <span>输入编码</span>
                                            </span>
                                        <div class="product_code_wrap" >
                                            <ul>
                                                <li class="ellipsis" v-for="item in row.code_list" v-text="item"></li>
                                            </ul>
                                            <div class="code_num_wrap">
                                                共：{{row.code_num}}条
                                            </div>
                                        </div>
                                    </el-popover>
                                </div>
                                <div class="total_num">
                                    共<span v-if="row.total_num" v-text="row.total_num"></span>
                                </div>
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column label="操作" width="58" align="center">
                        <template slot-scope="{row,$index}">
                            <el-tooltip placement="top" content="删除行" >
                              <span class="handle_icon_wrap handle_icon_danger_wrap" @click="handleClickDel(row,$index)">
                                  <i class="iconfont icon-shanchu1"></i>
                              </span>
                            </el-tooltip>
                        </template>
                    </el-table-column>
                </el-table>
                <div class="add_product_btn">
                    <span @click="handleClickAdd"><i class="el-icon-plus"></i>新增行</span>
                </div>
            </div>

            <div class="warehouse_add_from">
                <el-form ref="formData"  :model="formData"  :rules="formDataRules"  label-position="top"  size="small">
                    <el-form-item label="附件" class="label-bold" prop="file_list">
                        <div class="file_upload_wrap">
                            <div v-if="formData.file_list.length===0" class="file_outer_wrap">
                                <img alt=""  src="https://download.hecoos.com/enlightv/2023-31/3wy8ZnscPAjXMD2XmQhb.png"  width="36">
                                <p class="file_hint">点击或者将文件拖拽到这里上传</p>
                                <p class="file_type_hint">支持.rar .zip .doc .docx .pdf .jpg...</p>
                                <input class="upload_input"  multiple type="file" @change="handleUploadFileChange($event)">
                            </div>
                            <ul v-else class="upload_file_list">
                                <li v-for="file in formData.file_list" class="upload_file_item">
                                    <div class="file_left_wrap">
                                        <img alt="" class="file_img"  src="https://download.hecoos.com/enlightv/2023-37/chyZ4zyQiQkR5byRwSCT.png">
                                        <div class="file_info_wrap">
                                            <p class="file_name" v-text="file.file_name"></p>
                                            <p class="file_size" v-text="file.file_size"></p>
                                        </div>
                                    </div>
                                    <div class="file_right_wrap">
                                        <el-tooltip content="预览"  effect="dark"  placement="top">
                                            <span class="handle_icon_wrap" @click="handleClickPreview(file)">
                                                <i class="iconfont icon-yanjing"></i>
                                            </span>
                                        </el-tooltip>
                                        <span class="line"></span>
                                        <el-tooltip content="删除"  effect="dark"  placement="top">
                                            <span class="handle_icon_wrap handle_icon_danger_wrap"  @click="formData.file_list.splice(file_idx,1)">
                                                <i class="iconfont icon-shanchu1"></i>
                                            </span>
                                        </el-tooltip>
                                    </div>
                                </li>
                                <li class="upload_file_btn_wrap">
                                    <i class="el-icon-plus"></i>
                                    <span>添加附件</span>
                                    <input class="upload_input"  multiple  type="file"  @change="handleUploadFileChange($event)">
                                </li>
                            </ul>
                        </div>
                    </el-form-item>
                    <el-form-item label="备注信息" class="label-bold" prop="note">
                        <el-input type="textarea" :rows="5" v-model="formData.note" placeholder="请输入备注信息"></el-input>
                    </el-form-item>
                </el-form>
            </div>
        </div>
        <div class="warehouse_add_bottom">
            <el-button size="small" @click="handleClickClose">取消</el-button>
            <el-button :disabled="btnDisabled" size="small" type="primary" @click="handleClickConfirm">提交</el-button>
        </div>
        <SelectProductIn :selectProductInDialog.sync="selectProductInDialog" v-if="selectProductInDialog" @success="selectProductSuccess" />
        <CodeIdentification :codeIdentificationDialog.sync="codeIdentificationDialog" v-if="codeIdentificationDialog" :sourceType="'in'" :productInfo="productInfo" :selectedCodeData="selectedCodeData" @success="selectCodeSuccess" />
        <el-image :preview-src-list="previewImgList" :src="previewImgSrc" ref="preview_img" style="display: none"></el-image>

    </div>
</template>
<script>
import {mapState} from "vuex";
import {stockList,addStockIn,searchProducts,codeInGetProduct} from "@/api"
import {formatFileSize,removeTag} from "@/utils";
import {getOSSData, uploadImg} from "@/utils/uploadOss";
import SelectProductIn from  "../component/select_product_in"
import CodeIdentification from  "../component/code_identification"
import {EventBus} from '@/utils/eventBus';
export default {
    name: 'InWarehouseAdd',
    components: {
        SelectProductIn,
        CodeIdentification
    },
    data() {
        return {
            loading:false,
            btnDisabled:false,
            formData:{
                productData:[
                    {
                        name:'',
                        sku_id:'',
                        sku_key:'',
                        stock_id:'',
                        unit:'',
                        cost_price:'',
                        no_code_num:0, //输入的无编码数量
                        code_num:0, //选择的有编码数量
                        code_list:[], //选择的编码
                        total_num:0, //选择的总数量
                        not_found_code:[], // 不存在的编码
                        unmatched_code:[],//已存在未绑定的编码
                    }
                ],
                file_list:[],
                note:''
            },
            formDataRules:{},
            productList:[],//产品
            stock_id:'',
            stockList:[],
            codeIdentificationDialog:false, //选择编码/编码识别
            productInfo:null,//选中的产品
            selectProductInDialog:false,//选择入库产品
            selectedCodeData:[], //已选编码
            previewImgList: [],
            previewImgSrc: "",
            project_manage_id:'',

        }
    },
    computed: {
        ...mapState(['inventoryProductData']),
    },
    watch: {
        $route: {
            handler(to, from) {
                if(to.params.from && to.params.from == 'warehouse'){
                    this.$route.meta.parentMeta = {
                        title: '仓库管理',
                        path: '/warehouse_management',
                        icon: "icon-shezhi",
                    }
                }else if(from && from.name == 'InWarehouseManagement'){
                    this.$route.meta.parentMeta = {
                        title: '入库管理',
                        path: '/in_warehouse_management',
                        icon: "icon-shezhi",
                    }
                }
            },
            immediate: true, // 可选，是否立即执行
            deep: true // 如果路由有嵌套参数可能需要
        },
        // "inventoryProductData": function (newVal,oldVal) {
        //     if(newVal && newVal.length){
        //         this.setInventoryProductData(newVal)
        //     }
        // }
    },
    mounted() {

    },
    created() {

        if(this.$route.query.project_manage_id){
            this.project_manage_id = this.$route.query.project_manage_id
        }
        this.getStockList()
    },
    activated() {
        // 组件被激活
        if(this.inventoryProductData && this.inventoryProductData.length){
            this.setInventoryProductData(this.inventoryProductData)
        }
    },
    methods: {
        setInventoryProductData(data){
            if(data && data.length){
                this.formData.productData = []
                data.forEach((item)=>{
                    let json = {
                        name:item.name,
                        sku_id:item.sku_id,
                        sku_key:item.sku_key,
                        stock_id:item.stock_id,
                        unit:item.unit,
                        cost_price:'',
                        no_code_num:0, //输入的无编码数量
                        code_num:0, //选择的有编码数量
                        code_list:[], //选择的编码
                        total_num:0, //选择的总数量
                        not_found_code:[], // 不存在的编码
                        unmatched_code:[],//已存在未绑定的编码
                    }
                    this.formData.productData.push(json)
                })
                this.$store.dispatch("inventoryProductData", []);
            }
        },
        // 编码识别
        handleClickCodeIdentification(){
            this.productInfo = null
            this.selectedCodeData = []
            this.formData.productData.forEach(item =>{
                 this.selectedCodeData = this.selectedCodeData.concat(item.code_list)
            })
            this.codeIdentificationDialog = true
        },
        getProductStock(){

        },

        // 搜索产品
        productNameQuerySearchAsync(queryString, cb,row){
            searchProducts({
                keyword:queryString,
            }).then(res => {
                if (res.code === 200) {
                    let data = res.data ? res.data.map((item)=>{
                        return item
                    }) : []

                    let info = data.find(find =>find.name == row.name)
                    if(info){
                        this.$set(row,'sku_id',info.sku_id)
                        this.$set(row,'sku_key',info.sku_key)
                        this.$set(row,'unit',info.unit)
                    }else{
                        this.$set(row,'sku_id','')
                        this.$set(row,'sku_key','')
                        this.$set(row,'unit','')
                    }
                    this.clearInfoData(row)

                    // this.productList = data
                    cb(data);
                }
            })

        },
        // 选择产品
        handleSelectProduct(event,row){
            this.$set(row,'sku_id',event.sku_id)
            this.$set(row,'sku_key',event.sku_key)
            this.$set(row,'unit',event.unit)
            this.clearInfoData(row) // 清空数据
        },

        // 获取仓库
        getStockList(){
            stockList({}).then(res => {
                if (res.code === 200) {
                    this.stockList = res.data
                }
            })
        },
        // 删除
        handleClickDel(row,index){
            if(this.formData.productData.length == 1) return this.$message.error('当前数据行不可删除，最少保留一行')
            this.formData.productData.splice(index,1)
        },
        // 新增行
        handleClickAdd(){
            let json = {
                name:'',
                sku_id:'',
                sku_key:'',
                stock_id:'',
                unit:'',
                cost_price:'',
                no_code_num:0, //输入的无编码数量
                code_num:0, //选择的有编码数量
                code_list:[], //选择的编码
                total_num:0, //选择的总数量
                not_found_code:[], // 不存在的编码
                unmatched_code:[],//已存在未绑定的编码
            }
            this.formData.productData.push(json)
        },
        // 输入数量
        handleChangeNum(row){
            const num = row.no_code_num;
            const regex = /^[1-9]\d*$/; // 正整数的正则表达式
            if (!regex.test(num)) {
                this.$set(row,'no_code_num',0)
            }
            this.$set(row,'total_num',Number(row.no_code_num) + Number(row.code_num))
        },
        // 选择产品编码
        handleClickSelectCode(row){
            if(row.name == '')return this.$message.error('请先选择产品')
            this.productInfo = row
            this.selectedCodeData = []
            this.formData.productData.forEach(item =>{
                this.selectedCodeData = this.selectedCodeData.concat(item.code_list)
            })
            this.codeIdentificationDialog = true
        },
        // 选择编码后回调
        selectCodeSuccess(data){
            let code_type = data.type  // 'encoding_detection' ==  代表已绑定产品识别码 ；  'manual_entry_binding' == 代表未绑定产品识别码
            console.log(code_type);
            if(this.productInfo && this.productInfo.name){
                let {code_list, selected_code_list, not_found_code, unmatched_code} = data
                if(code_type == 'encoding_detection'){
                    this.encodingDetectionFunction(data,code_type)
                }else{
                    this.$set(this.productInfo,'code_list',selected_code_list.concat(code_list)) //已选的+ 新增的
                    this.$set(this.productInfo,'not_found_code',this.productInfo.not_found_code.concat(not_found_code)) //不存在的
                    this.$set(this.productInfo,'unmatched_code',this.productInfo.unmatched_code.concat(unmatched_code)) //存在没绑定
                    this.$set(this.productInfo,'code_num',this.productInfo.code_list.length)
                    this.$set(this.productInfo,'total_num',Number(this.productInfo.no_code_num) + Number(this.productInfo.code_num))
                    this.$set(this.productInfo,'code_type',this.productInfo.code_type == 'encoding_detection' ? 'encoding_detection' : code_type)
                }
                this.productInfo = null
            }else{
                // 编码识别
               this.encodingDetectionFunction(data,code_type)
            }
        },
        encodingDetectionFunction(dataInfo,code_type){
            this.loading = true
            let code_list = []
            if(this.formData.productData.length == 1){
                if(!this.formData.productData[0].stock_id && !this.formData.productData[0].name && !this.formData.productData[0].cost_price && !this.formData.productData[0].total_num && !this.formData.productData[0].unit) {
                    this.formData.productData.splice(0,1)
                }
            }
            this.formData.productData.forEach((item, key) => {
                let code = item.code_list.map(map => map.code)
                code_list = [...code_list, ...code]
            })
            let codeList = dataInfo.code_list.filter(item => !code_list.includes(item));
            if(codeList.length != dataInfo.code_list.length){
                this.$message.error('检查到有重复的编码已经为您去重')
            }
            if(codeList.length == 0){ this.loading = false; return  false }

            codeInGetProduct({code_list:codeList}).then(res => {
                if (res.code === 200) {
                    let {data} = res
                    data.forEach((item,key)=>{
                        this.mergeProductFunction(item,code_type)
                    })
                }
                this.loading = false
            })
        },
        // 合并产品
        mergeProductFunction(row,code_type){
            let flag = true
            if(this.formData.productData.length>0){
                this.formData.productData.forEach((item, index) => {
                    if(item.name == row.name && item.sku_id == row.sku_id && item.sku_key == row.sku_key && item.cost_price == row.cost_price && item.unit == row.unit){
                        let code_list = row.code_list.map((map)=>{return {code:map}})
                        this.$set(item,'cost_price',row.cost_price)
                        this.$set(item,'code_list',item.code_list.concat(code_list))
                        this.$set(item,'code_num',item.code_list.length)
                        this.$set(item,'total_num',Number(item.code_num) + Number(item.no_code_num))
                        this.$set(item,'code_type',item.code_type == 'encoding_detection' ? 'encoding_detection' : code_type)
                        flag = false
                    }
                })
            }
            if(flag){
                let json = {
                    name:row.name,
                    stock_id:row.stock_id,
                    sku_id:row.sku_id,
                    sku_key:row.sku_key,
                    unit:row.unit,
                    cost_price:row.cost_price,
                    code_num:row.code_num, //选择的编码数量
                    code_list:row.code_list, //选择的编码
                    no_code_num:row.no_code_num, //选择的编码数量
                    total_num:row.total_num, //选择的总数量
                    not_found_code:[], // 不存在的编码
                    unmatched_code:[],//已存在未绑定的编码
                    code_type:code_type
                }
                this.formData.productData.push(json)
            }
            console.log(this.formData.productData);
        },
        // 选择产品
        handleClickSelectProduct(row){
            this.productInfo = row
            this.selectProductInDialog = true
        },
        // 选择产品回调
        selectProductSuccess(data){
            if(this.productInfo){
                this.$set(this.productInfo,'name',data.name)
                this.$set(this.productInfo,'sku_id',data.sku_id)
                this.$set(this.productInfo,'sku_key',data.sku_key)
                this.$set(this.productInfo,'unit',data.unit)
                this.clearInfoData() // 清空数据
            }
        },
        // 清空数据
        clearInfoData(row){
            this.$set(this.productInfo ? this.productInfo :row,'code_list',[])
            this.$set(this.productInfo ? this.productInfo :row,'not_found_code',[])
            this.$set(this.productInfo ? this.productInfo :row,'unmatched_code',[])
            this.$set(this.productInfo ? this.productInfo :row,'code_num',0)
            this.$set(this.productInfo ? this.productInfo :row,'no_code_num',0)
            this.$set(this.productInfo ? this.productInfo :row,'total_num',0)
            this.$set(this.productInfo ? this.productInfo :row,'cost_price','')
            this.$set(this.productInfo ? this.productInfo :row,'code_type','')
        },


        // 批量选择仓库
        handleChangeProductStockAll($event){
            this.formData.productData.forEach(item => {
                this.$set(item,'stock_id',$event)
            })
            this.$forceUpdate()
            this.$refs.stockPopover.doClose()
        },
        // 上传附件
        handleUploadFileChange(e){
            const files = e.target.files
            const that = this;
            Array.from(files).forEach(file => {
                uploadImg(file, 50).then(res => {
                    if (res.file_path) {
                        res.file_size = formatFileSize(file.size)
                        this.formData.file_list.push(res)
                        e.target.value = ''
                    }
                    e.target.value = ''
                }).catch(error => {
                    e.target.value = ''
                })
            })
        },
        // 预览
        handleClickPreview(file){
            if (file.file_type.indexOf("image") > -1) {
                this.previewImgList = [file.file_path];
                this.previewImgSrc = file.file_path;
                this.$refs.preview_img.showViewer = true;
            } else {
                if (file.file_type.indexOf("pdf") > -1) {
                    window.open(file.file_path);
                } else {
                    this.$message.error("当前文件格式不支持预览，请下载后查看");
                }
            }
        },
        handleClickClose() {

            if (this.formData.note || this.formData.file_list.length > 0 || (this.formData.productData.length > 0 && this.formData.productData.filter(item => (item.name || item.stock_id || item.cost_price || item.total_num || item.unit)).length>0 )){
                const h = this.$createElement;
                this.$msgbox({
                    title: '取消',
                    message: h('div', null, [
                        h('span', null, '取消后，编辑内容不保留，是否取消！'),
                    ]),
                    iconClass: `icon-jinggao iconfont prompt_message_icon status1`,
                    customClass: 'prompt_message_custom',
                    confirmButtonText:  '确定',
                    closeOnClickModal: false,
                    closeOnPressEscape: false,
                    showCancelButton: true,
                    confirmButtonClass:  'el-button--primary',
                    beforeClose: (action, instance, done) => {
                        if (action === 'confirm') {
                            done();
                        } else {
                            done();
                        }
                    }
                }).then(() => {
                    removeTag(this.$route)
                    this.$router.go(-1);
                }).catch(() => {
                })
            }else{
                removeTag(this.$route)
                this.$router.go(-1);
            }
        },
        handleClickConfirm(){
            this.$refs.formData.validate((valid) => {
                if (valid) {
                    let flag = false
                    if(this.formData.productData.length == 0){
                        return  this.$message.error(`至少入库一个产品`)
                    }
                    this.formData.productData.forEach((item,index) => {

                        if(!item.name && !flag){
                            this.$message.error(`请选择第${index+1}个产品`)
                            flag = true
                        }
                        if(!item.stock_id && !flag){
                            this.$message.error(`请选择${item.name}仓库`)
                            flag = true
                        }
                        if(!item.total_num && !flag){
                            this.$message.error(`请输入${item.name}入库数量`)
                            flag = true
                        }
                        // if(item.code_list && item.code_list.length>0){
                        //     item.code_list.forEach(codeItem => {
                        //         this.$set(codeItem,'cost_price',item.cost_price)
                        //     })
                        // }
                    })
                    if(flag){return  false}
                    let postData = {
                        stock_type:'general', //出入库类型（普通）
                        product_list:this.formData.productData,
                        files:this.formData.file_list,
                        note:this.formData.note,
                    }
                    if(this.project_manage_id){
                        postData.related_type = 'project_manage'  //业务类型 （项目）
                        postData.related_id = this.project_manage_id
                    }

                    const h = this.$createElement;
                    this.$msgbox({
                        title: '提交入库',
                        message: h('div', null, [
                            h('span', null, '确定执行入库操作吗？ \r\n 提交后无法撤回，请谨慎操作。'),
                        ]),
                        iconClass: `icon-jinggao iconfont prompt_message_icon status1`,
                        customClass: 'prompt_message_custom',
                        confirmButtonText:  '确定',
                        closeOnClickModal: false,
                        closeOnPressEscape: false,
                        showCancelButton: true,
                        confirmButtonClass:  'el-button--primary',
                        beforeClose: (action, instance, done) => {
                            if (action === 'confirm') {
                                done();
                            } else {
                                done();
                            }
                        }
                    }).then(() => {
                        this.btnDisabled = true
                        addStockIn(postData).then(res => {
                            if (res.code === 200) {
                                this.$message({
                                    type: 'success',
                                    message:'入库成功',
                                    duration: 1500,
                                    onClose: () => {
                                        removeTag(this.$route)
                                        EventBus.$emit('inventoryInUpdated');
                                        this.$router.go(-1);
                                        this.btnDisabled = false
                                    }
                                })
                            }else{
                                this.btnDisabled = false
                            }
                        })
                    }).catch(() => {
                    })


                }
            })
        }
    },
}
</script>

<style lang="scss" scoped >

@import "@/styles/inventory_management.scss";
</style>